import styled from 'styled-components';

export const LoadingStyled = styled.div`
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .yamaha_loading {
    width: 180px;
    height: auto;
  }

  .theme_standard_loading {
  }
`;
